module.exports = __webpack_public_path__ + "static/media/loadingIMG.5de80a06.mp4";